const actionTypeIdentifier = '70C7688D-9685-4B18-BF9B-B8DD1195FE84';

export const getInventoryEquipment = `GET-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`;
export const setInventoryEquipmentError = `SET-INVENTORY-EQUIPMENT-ERROR-${actionTypeIdentifier}`;
export const setInventoryEquipmentColSearchStr = `SET-INVENTORY-EQUIPMENT-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortInventoryEquipmentItems = `SORT-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`;
export const setInventoryEquipmentPageSize = `SET-INVENTORY-EQUIPMENT-PAGESIZE-${actionTypeIdentifier}`;
export const setInventoryEquipmentFilter = `SET-INVENTORY-EQUIPMENT-FILTER-${actionTypeIdentifier}`;
export const applyInventoryEquipmentFilter = `APPLY-INVENTORY-EQUIPMENT-FILTER-${actionTypeIdentifier}`;
export const getInventoryEquipmentDetailsById = `GET-INVENTORY-EQUIPMENT-DETAILS-${actionTypeIdentifier}`;
export const getInventoryEquipmentComments = `GET-INVENTORY-EQUIPMENT-COMMENTS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-INVENTORY-EQUIPMENT-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const getEquipmentdropDownList = `GET-INVENTORY-EQUIPMENT-DROPDOWN-${actionTypeIdentifier}`;
export const setDefaultInventoryEquipment = `SET-DEFAULT-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`;
export const resetInventoryEquipmentData = `RESET-INVENTORY-EQUIPMENT-DATA-${actionTypeIdentifier}`;
export const setVendorsLoading = `SET_VENDORS_LOADING-${actionTypeIdentifier}`;
export const getAllVendors = `GET_ALL_VENDORS-${actionTypeIdentifier}`;
export const setCircuitTypeLoading = `SET_CIRCUIT_TYPE_LOADING-${actionTypeIdentifier}`;
export const getAllCircuitTypes = `GET_ALL_CIRCUIT_TYPES-${actionTypeIdentifier}`;
export const setContractsLoading = `SET_CONTRACTS_LOADING-${actionTypeIdentifier}`;
export const getAllContracts = `GET_ALL_CONTRACTS-${actionTypeIdentifier}`;
export const setGlCodesLoading = `SET_GL_CODES_LOADING-${actionTypeIdentifier}`;
export const getAllGlCodes = `GET_ALL_GL_CODES-${actionTypeIdentifier}`;
export const setCostCentersLoading = `SET_COST_CENTERS_LOADING-${actionTypeIdentifier}`;
export const getAllCostCenters = `GET_ALL_COST_CENTERS-${actionTypeIdentifier}`;
export const setCompanyCodesLoading = `SET_COMPANY_CODES_LOADING-${actionTypeIdentifier}`;
export const getAllCompanyCodes = `GET_ALL_COMPANY_CODES-${actionTypeIdentifier}`;
export const setEquipmentDropdownError = `SET_EQUIPMENT_DROPDOWN_ERROR-${actionTypeIdentifier}`;
export const insertEquipmentComments = `INSERT-EQUIPMENT-COMMENTS-${actionTypeIdentifier}`;
export const resetEquipmentComments = `RESET-EQUIPMENT-COMMENTS-${actionTypeIdentifier}`;

export const inventoryEquipmentModel = {
    inventoryEquipmentDetails: {
        equipmentId : 0,
        equipmentTypeId: 0,
        model : "",
        productName : "",
        equipmentStatusId : 0,
        vendorId: 0,
        vendorName: "",   
        currency : "",
        circuitTypeId: 0,
        circuitTypeName: "",
        contractId: 0,
        contractName: "",
        orderCost : null,
        discountedOrderCost : null,
        mrc : null,
        nrc : null,
        glCodeId: 0,
        glCodeName: "",
        costCodeId: 0,
        costCodeName: "",
        companyCodeId: 0,
        companyCodeName: "",
        vipId : 0,
    }
}